import TeamEditForm from "./team-edit-form";

export default TeamEditForm;